module.exports = __webpack_public_path__ + "static/media/Cersei Lannister 2.41b4003a.jpg";